(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-demand"]) return;
  try {
    
(() => {
  'use strict';
  const root = document.getElementById('gb-demand');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const dialog = document.getElementById('gb-shipping-dialog');
  const form = document.getElementById('gb-shipping-waitlist');
  const supported = new Set(root.dataset.supported.split(',').map(s => s.trim()).filter(Boolean));
  const base = root.dataset.root.replace(/\/$/, '');
  const store = {get(k){try{return JSON.parse(sessionStorage.getItem(k));}catch(_){return null;}},set(k,v){try{sessionStorage.setItem(k,JSON.stringify(v));}catch(_){}},remove(k){try{sessionStorage.removeItem(k);}catch(_){}}};
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true && window.Shopify?.customerPrivacy?.currentVisitorConsent?.().analytics === 'yes';
  const lang = () => document.documentElement.lang.startsWith('en') ? 'en' : 'de';
  const text = (de,en) => lang() === 'en' ? en : de;
  let source, intent, pending = false, countrySelect, latestCart, checkoutReady = false, resumedCart;
  let visitor = {visitor_country:'unknown',visitor_region:''};
  const uid = () => crypto.randomUUID();
  function privacyReady() {
    const region = window.Shopify?.customerPrivacy?.getRegion?.() || '';
    visitor = {visitor_country:/^[A-Z]{2}/.test(region) ? region.slice(0,2) : 'unknown',visitor_region:region.slice(2)};
    if (!allowed()) {source = intent = undefined; ['gb-demand-source','gb-demand-intent','gb-demand-quantity','gb-demand-signup'].forEach(store.remove); return;}
    source = store.get('gb-demand-source');
    if(source && Date.now()-source.created>1800000) source=null;
    if (!source) {
      const params = new URLSearchParams(location.search);
      source = {landing_page:location.pathname,referrer:'',created:Date.now()};
      try {source.referrer = document.referrer ? new URL(document.referrer).hostname : '';} catch(_){}
      ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(key => {source[key]=(params.get(key)||'').replace(/[^\p{L}\p{N} _.,:/-]/gu,'').slice(0,100);});
      store.set('gb-demand-source',source);
    }
    intent = store.get('gb-demand-intent');
    if(!intent || Date.now()-intent.created>86400000) intent={id:uid(),created:Date.now(),seen:{}};
    store.set('gb-demand-intent',intent);
    const staleSignup=store.get('gb-demand-signup');
    if(staleSignup && Date.now()-staleSignup.saved_at>=600000)store.remove('gb-demand-signup');
    if(resumedCart){recordIntent(resumedCart.country,resumedCart.cart);resumedCart=null;}
    if (document.querySelector('[data-demand-success]')) {
      const previous = store.get('gb-demand-signup');
      if (previous) {store.remove('gb-demand-signup');if(Date.now()-previous.saved_at<600000)publish('shipping_interest',{...previous,stage:'signup_accepted',email_signup_status:'accepted_not_confirmation',intent_value:0});}
    }
    checkQuantity();
  }
  function publish(name, data) {
    if (!allowed() || !source || !window.Shopify?.analytics?.publish) return;
    const {created,...attribution}=source;
    window.Shopify.analytics.publish('gb:'+name,{...attribution,...visitor,event_id:uid(),timestamp:new Date().toISOString(),currency:root.dataset.currency,...data});
  }
  function item(v,p,quantity=1) {
    const sizeIndex = p.options?.findIndex(o => /^(size|größe|groesse|taille)$/i.test(o));
    return {item_id:String(p.id),item_name:p.title,item_variant:v.title,variant_id:String(v.id),size:sizeIndex >= 0 ? v.options[sizeIndex] : v.title,price:v.price/100,quantity};
  }
  const product = JSON.parse(document.getElementById('gb-demand-product').textContent);
  async function cartSnapshot() {
    const response = await fetch(base+'/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},signal:AbortSignal.timeout(4000)});
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    latestCart={currency:cart.currency,value:cart.total_price/100,quantity:cart.item_count,items:cart.items.map(i=>({item_id:String(i.product_id),item_name:i.product_title,item_variant:i.variant_title||'',variant_id:String(i.variant_id),size:i.options_with_values?.find(o=>/^(size|größe|groesse|taille)$/i.test(o.name))?.value||i.variant_title||'',price:i.final_price/100,quantity:i.quantity})),lines:cart.items.map(i=>({key:i.key,quantity:i.quantity}))};
    return latestCart;
  }
  function publicCart(cart) {const {lines,...safe}=cart;return safe;}
  function countryName(code) {try{return new Intl.DisplayNames([lang()],{type:'region'}).of(code);}catch(_){return code;}}
  function translate(scope) {
    scope.querySelectorAll('[data-gb-i18n]').forEach(el=>{el.textContent=el.dataset[lang()];});
    scope.querySelectorAll('[data-aria-de]').forEach(el=>el.setAttribute('aria-label',el.dataset[lang()==='en'?'ariaEn':'ariaDe']));
  }
  translate(root);
  function showBlocked(country) {
    translate(root);
    document.getElementById('gb-shipping-title').textContent=text('Kein Versand nach '+countryName(country)+'.','No shipping to '+countryName(country)+'.');
    document.getElementById('gb-waitlist-tags').value='shipping-waitlist,shipping-waitlist-'+country;
    if (!dialog.open) dialog.showModal();
  }
  root.querySelectorAll('[data-demand-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
  const cartForm = document.querySelector('.gb-cart-page form[action$="/cart"]');
  if (cartForm) {
    const template=document.getElementById('gb-delivery-template');
    const anchor=cartForm.querySelector('.gb-cart-actions');
    anchor.before(template.content.cloneNode(true));
    countrySelect=document.getElementById('gb-delivery-country');
    translate(countrySelect.parentElement);
    // ISO country codes; no dependence on active Shopify markets.
    const countries='AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'.split(' ');
    countries.sort((a,b)=>countryName(a).localeCompare(countryName(b),lang())).forEach(code=>countrySelect.add(new Option(countryName(code),code)));
    countrySelect.value=store.get('gb-delivery-country')||'AT';
    if(!countrySelect.value)countrySelect.value='AT';
    countrySelect.addEventListener('change',()=>store.set('gb-delivery-country',countrySelect.value));
    // Require delivery selection only for checkout, never for changing cart quantities.
    countrySelect.required=false;
    cartForm.addEventListener('submit',async event=>{
      if(checkoutReady)return;
      if(event.submitter?.name !== 'checkout') {
        if(allowed()) store.set('gb-demand-quantity',{before:[...cartForm.querySelectorAll('[name="updates[]"]')].map(el=>Number(el.defaultValue)),time:Date.now()});
        return;
      }
      const country=countrySelect.value;
      if(!country){event.preventDefault();countrySelect.required=true;countrySelect.reportValidity();countrySelect.required=false;return;}
      if(supported.has(country)) {
        if(allowed()) {
          event.preventDefault();
          if(pending)return;pending=true;
          const button=event.submitter;
          const quantities=[...cartForm.querySelectorAll('[name="updates[]"]')];
          const changed=quantities.some(el=>el.value!==el.defaultValue);
          if(!changed) await Promise.race([cartSnapshot().then(cart=>publish('checkout_attempt',{...publicCart(cart),delivery_country:country,intent_id:intent?.id||'',supported:true})).catch(()=>{}),new Promise(resolve=>setTimeout(resolve,500))]);
          else publish('checkout_attempt',{delivery_country:country,intent_id:intent?.id||'',supported:true,quantity:quantities.reduce((n,el)=>n+Number(el.value),0),cart_value_status:'pending_native_update'});
          // Native checkout receives edits and validates inventory/prices. Never delay a sale on analytics.
          checkoutReady=true;cartForm.requestSubmit(button);
        }
        return;
      }
      event.preventDefault();
      if(pending)return;
      pending=true;
      try {
        // Save edited quantities before taking the demand snapshot; checkout has not started.
        const updates=[...cartForm.querySelectorAll('[name="updates[]"]')].map(el=>Number(el.value));
        const changed=[...cartForm.querySelectorAll('[name="updates[]"]')].some(el=>el.value!==el.defaultValue);
        if(changed) {
          const result=await fetch(base+'/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates}),signal:AbortSignal.timeout(4000)});
          if(!result.ok)throw new Error('Update failed');
          location.assign(base+'/cart?gb_delivery_intent='+encodeURIComponent(country));return;
        }
        showBlocked(country);
        const cart=await cartSnapshot();
        if(cart.quantity===0)return;
        recordIntent(country,cart);
      } catch(_) {showBlocked(country);} finally {pending=false;}
    });
  }
  function recordIntent(country,cart) {
    if(!allowed()||!intent)return;
    if(intent.seen[country])return;
    intent.seen[country]=true;store.set('gb-demand-intent',intent);
    const data={...publicCart(cart),delivery_country:country,intent_id:intent.id,supported:false};
    publish('checkout_attempt',data);
    publish('shipping_interest',{...data,stage:'blocked',email_signup_status:'not_submitted',intent_value:cart.value});
  }
  form.addEventListener('submit',event=>{
    const country=countrySelect?.value||store.get('gb-delivery-country');
    if(!country||supported.has(country)){event.preventDefault();return;}
    // No email or other customer field is read by analytics.
    if(allowed() && latestCart && !form.dataset.submitting) {
        form.dataset.submitting='true';
        const data={...publicCart(latestCart),delivery_country:country,intent_id:intent?.id||'',saved_at:Date.now()};
        store.set('gb-demand-signup',data);
        publish('shipping_waitlist_submitted',{...data,email_signup_status:'submitted'});
    }
  });
  async function checkQuantity() {
    if(!cartForm||!allowed())return;
    const previous=store.get('gb-demand-quantity');
    if(!previous)return;
    store.remove('gb-demand-quantity');
    if(Date.now()-previous.time>600000)return;
    try {const cart=await cartSnapshot();const now=cart.lines.map(i=>i.quantity);if(JSON.stringify(now)!==JSON.stringify(previous.before))publish('cart_quantity_changed',{...publicCart(cart),previous_quantities:previous.before});}catch(_){}
  }
  document.addEventListener('click',event=>{
    const card=event.target.closest('.gb-product-card[data-demand-id]');
    if(card&&event.target.closest('a'))publish('product_card_clicked',{items:[{item_id:card.dataset.demandId,item_name:card.dataset.demandName,variant_id:card.dataset.demandVariant,item_variant:card.dataset.demandSize,size:card.dataset.demandSize,price:Number(card.dataset.demandPrice)/100,quantity:1}]});
  });
  document.addEventListener('change',event=>{
    if(!product||!event.target.matches('[data-variant-select]'))return;
    const variant=product.variants.find(v=>String(v.id)===event.target.value);
    if(variant)publish('variant_selected',{items:[item(variant,product)]});
  });
  document.addEventListener('visitorConsentCollected',privacyReady);
  if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)privacyReady();});
  const resume=new URLSearchParams(location.search).get('gb_delivery_intent');
  if(resume&&countrySelect&&!supported.has(resume)&&[...countrySelect.options].some(o=>o.value===resume)) {
    countrySelect.value=resume;store.set('gb-delivery-country',resume);showBlocked(resume);
    cartSnapshot().then(cart=>{if(intent)recordIntent(resume,cart);else if(allowed())resumedCart={country:resume,cart};}).catch(()=>{});
    const url=new URL(location.href);url.searchParams.delete('gb_delivery_intent');history.replaceState(null,'',url.pathname+url.search+url.hash);
  }
  if(root.querySelector('[data-demand-success],[data-demand-errors]')) {
    const country=store.get('gb-delivery-country');if(country&&!supported.has(country))showBlocked(country);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
